import { useMutation, useQueryClient } from '@tanstack/react-query';

import { MutationKey, QueryKey } from '@/config/query-client';
import { shareOrganizationFile } from '@/api/v4/organization-files.api';
import { companyIdState } from '../../company.state';
import type { ShareFilePayload } from '@/features/action-panel/files/edit-file';
import { useAtomValue } from 'jotai';

export const useShareCompanyFile = () => {
  const queryClient = useQueryClient();
  const companyId = useAtomValue(companyIdState);

  const mutation = useMutation({
    mutationFn: async ({ fileId, ...payload }: ShareFilePayload) => {
      if (!companyId) {
        return;
      }
      return shareOrganizationFile(companyId, fileId, payload);
    },
    mutationKey: [MutationKey.CompanyFileShare],
    onSuccess: async (_data, variables) => {
      const params = {
        withAccessToOrganizationFile: variables.fileId,
      };

      await queryClient.invalidateQueries({
        queryKey: [QueryKey.CompanyFiles],
      });
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.Users, params],
      });
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.TeamOptions, params],
      });
    },
  });

  return {
    shareCompanyFile: mutation.mutateAsync,
  };
};
